let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2c1pi")).then(() => parcelRequire('coZXG'));